import { get } from '~/services/apiClient';
import { getConfig } from '~/services/apiConfig.js';
import { TIMEZONES } from '~/common/constants';
import { handleErrors } from '~/common/helpers';

const url = getConfig(TIMEZONES).url;

export const fetchTimezones = () => {
  if (url) {
    return get(url)
      .then(handleErrors)
      .then((res) => res.json());
  } else {
    return Promise.reject(new Error(`Missing ${TIMEZONES} url.`));
  }
};
